<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="1400"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :footer="null"
    :destroyOnClose="true"
  >
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row>
            <a-col :span="5" style="padding: 0 12px">
              <a-form-item label="模板名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="queryParam.modelName" :allowClear="true" :disabled="disableded" />
              </a-form-item>
            </a-col>
            <a-col :span="5" style="padding: 0 12px">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  v-model="queryParam.installType"
                  @change="installChange"
                  :allowClear="true"
                  :disabled="disableded"
                >
                  <a-select-option v-for="type in installTypes" :key="type.code">{{ type.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5" style="padding: 0 12px">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.orderType" :allowClear="true" :disabled="disableded">
                  <a-select-option v-for="type in List" :key="type.orderTypeId">{{ type.typeName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div style="width: 100%;height: 2px;background-color: black"></div>
        <a-form :form="form">
          <a-row style="padding:0 30px">
            <a-col :span="2" style="display: flex;justify-content: center;flex-direction: column">
              <span style="font-weight: bold;margin-left: 20px;line-height: 30px">核销内容</span>
              <a-button class="twobtn" type="primary" @click="danxuan">单选</a-button>
              <a-button class="twobtn" type="primary" @click="duoxuan">多选</a-button>
              <a-button class="twobtn" type="primary" @click="xiala">下拉框</a-button>
              <a-button class="twobtn" type="primary" @click="wenben">单项填空</a-button>
            </a-col>
            <a-col :span="22" style="border: 1px solid #c7c7c7;margin-top: 30px">
              <div v-for="(item, number) in subjectList" :key="item.sort">
                <div
                  style="display: flex;width: 100%;border-bottom: 0.5px solid #c7c7c7;margin-bottom: 0px;border-top: 0.5px solid #c7c7c7;"
                >
                  <a-form-item
                    style="width: 45%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column"
                    v-if="item.subjectType == 0"
                  >
                    <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                    ><br />
                    <a-radio-group style="width: 50%">
                      <a-radio
                        :style="radioStyle"
                        v-for="type in item.optionList"
                        :key="type.optionSort"
                        :value="type.optionSort"
                      >
                        <span style="width: 100%;display: inline-block;text-align: left">
                          {{ type.optionName }}
                          <a-input
                            size="small"
                            v-if="type.isDescription == 1"
                            v-model="type.wenben"
                            style="display: inline-block;width: 200px;height: 30px;"
                          />
                          <span
                            v-if="type.isRequiredDescription == 1 && type.isDescription == 1"
                            style="color: red;margin-left: 10px;font-weight: bold"
                            >*</span
                          >
                        </span>
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>

                  <a-form-item
                    style="width: 45%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column"
                    v-if="item.subjectType == 1"
                  >
                    <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                    ><br />
                    <a-checkbox-group style="width: 50%">
                      <a-checkbox
                        :style="radioStyle"
                        v-for="type in item.optionList"
                        :key="type.optionSort"
                        :value="type.optionSort"
                      >
                        <span>{{ type.optionName }}</span>
                        <a-input
                          size="small"
                          v-if="type.isDescription == 1"
                          v-model="type.wenben"
                          style="width: 200px;height: 30px;"
                        />
                        <span
                          v-if="type.isRequiredDescription == 1 && type.isDescription == 1"
                          style="color: red;margin-left: 10px;font-weight: bold"
                          >*</span
                        >
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-item>

                  <a-form-item
                    style="width: 45%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column;text-align: left"
                    v-if="item.subjectType == 2"
                  >
                    <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                    ><br />
                    <a-select style="width:  50%" @change="handleChange">
                      <a-select-option v-for="type in item.optionList" :key="type.optionSort" :value="type.optionSort">
                        <span style="width: 60%;display: inline-block">
                          {{ type.optionName }}
                          <a-input
                            size="small"
                            v-if="type.isDescription == 1"
                            v-model="type.wenben"
                            style="display: inline-block;width: 200px;height: 30px;"
                          />
                        </span>
                        <!--<span style="width: 30%;display: inline-block">   <img alt="example" v-if="type.show" style="width: 30px;height: 30px" :src="type.picUrl"  /> </span>-->
                        <!--<span style="width: 30%;display: inline-block" v-if="type.textshow">   (说明：{{type.optionText}}) </span>-->
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item
                    style="width: 45%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column"
                    v-if="item.subjectType == 3"
                  >
                    <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                    ><br />
                    <a-input disabled="true" size="small" style="display: inline-block;width: 450px;height: 30px" />
                  </a-form-item>
                  <!--工具栏工具栏工具栏工具栏工具栏工具栏工具栏工具栏工具栏-->
                  <div style="width: 50%;display: flex;align-items: center">
                    <span @click="editState(number)"
                      ><a-button class="twobtn" type="primary" icon="form">编辑</a-button></span
                    >
                    <span @click="delState(number)" style="margin: 0 10px"
                      ><a-button type="danger" icon="delete">删除</a-button></span
                    >
                    <span @click="upState(number)"
                      ><a-button type="primary" class="twobtn" icon="arrow-up">上移</a-button></span
                    >
                    <span @click="downState(number)" style="margin: 0 10px"
                      ><a-button type="primary" class="twobtn" icon="arrow-down">下移</a-button></span
                    >
                    <span @click="uptopState(number)"
                      ><a-button type="primary" icon="vertical-align-top" class="twobtn">最前</a-button></span
                    >
                    <span @click="downbottomState(number)" style="margin: 0 10px"
                      ><a-button type="primary" icon="vertical-align-bottom" class="twobtn">最后</a-button></span
                    >
                  </div>
                </div>
                <div v-if="item.edition === '1'">
                  <span
                    v-if="item.subjectType == 3"
                    style="display: inline-block;width: 100px;text-align: left;line-height: 30px;padding-left: 30px;margin-top: 25px"
                    >标题</span
                  >
                  <a-input
                    v-if="item.subjectType == 3"
                    size="small"
                    v-model="item.subjectName"
                    style="display: inline-block;width: 500px;height: 30px"
                  />

                  <div v-if="item.subjectType == 3" style="padding-bottom: 20px">
                    <span
                      style="display: block;clear: both;margin-left: 70px;line-height: 26px;margin-top: 20px;margin-bottom: 20px"
                    >
                      <a-checkbox @change="onChanged(number)" style="margin: 0 15px">限制范围</a-checkbox>
                      <span>
                        <span>最小字数：</span
                        ><a-input-number
                          v-model="item.minLength"
                          :disabled="item.disable"
                          style="display: inline-block;width: 100px;height: 30px"
                        />
                      </span>
                      <span>
                        <span>最大字数：</span
                        ><a-input-number
                          v-model="item.maxLength"
                          :disabled="item.disable"
                          style="display: inline-block;width: 100px;height: 30px"
                        />
                      </span>
                      <br />

                      <a-checkbox
                        @change="needReply(4, number)"
                        style="margin: 0 15px"
                        :checked="item.isReply == 1 ? true : false"
                        >必答</a-checkbox
                      >
                    </span>
                    <div @click="FinallyState(number)" style="width: 100%;display: flex">
                      <a-button class="twobtn" type="primary" style="margin: 0 auto">完成编辑</a-button>
                    </div>
                  </div>
                  <div v-if="item.subjectType != 3" style="padding-bottom: 20px">
                    <div>
                      <span
                        style="display: inline-block;width: 100px;text-align: left;line-height: 30px;padding-left: 30px;margin-top: 25px"
                        >标题</span
                      >
                      <a-input
                        size="small"
                        v-model="item.subjectName"
                        style="display: inline-block;width: 500px;height: 30px"
                      />
                      <span
                        style="width: 100px;height: 30px;overflow:hidden;display:inline-block;position: relative;top: 10px;"
                        @click="titlepic(number, item.subjectType)"
                      >
                        <a-upload
                          :data-index="index"
                          :action="uploadUrlb"
                          :fileList="fileListTitle"
                          :headers="headers"
                          @preview="handlePreview"
                          @change="handleChangeTitle"
                          v-if="!item.picUrlstate"
                          :before-upload="beforeUpload"
                        >
                          <a-icon style="font-size: 26px;position: relative;top:2px;left: 10px;" type="file-image" />
                        </a-upload>
                        <span v-if="item.picUrlstate && item.pictureList.length != 0">
                          <!--                   <img alt="example" v-if="item.pictureList.length==2"     style="width: 30px;height: 30px;position: relative;left: 10px;" :src="item.pictureList[1].allpicUrl"  />-->
                          <img
                            alt="example"
                            style="width: 30px;height: 30px;position: relative;left: 10px;"
                            :src="item.pictureList[0].allpicUrl"
                          />
                        </span>
                      </span>
                    </div>
                    <span style="width: 100px;text-align: left;line-height: 30px;padding-left: 30px;float: left"
                      >选项文字</span
                    >
                    <span style="float: left">
                      <span style="display: block" v-for="(type, index) in item.optionList" :key="type.optionSort">
                        <a-input
                          size="small"
                          v-model="type.optionName"
                          style="display: inline-block;width: 500px;height: 30px"
                        />
                        <a-icon
                          style="font-size: 26px;margin-left: 10px;position: relative;top:2px;left: 0;"
                          type="minus-square"
                          @click="reducechoose(index, number, item.subjectType)"
                        />
                      </span>
                    </span>
                    <span style="float: right;width: 40%;height: 90px;position: relative;top:-30px;">
                      <span style="height: 30px;width: 100%;line-height: 30px;text-align: center">
                        <a-row style="width: 100%">
                          <a-col :span="4"></a-col>
                          <a-col :span="3">图片</a-col>
                          <a-col :span="8">说明</a-col>
                          <a-col :span="3">允许填空</a-col>
                          <a-col :span="6">允许填空去除</a-col>
                        </a-row>
                      </span>
                      <span
                        style="height: 30px;width: 100%"
                        v-for="(type, index) in item.optionList"
                        :key="type.optionName"
                      >
                        <a-row
                          style="width: 100%;line-height: 30px;text-align: center;overflow-y: hidden;height: 30px "
                        >
                          <a-col :span="4"></a-col>
                          <a-col :span="3" @click="dianji(index, number, item.subjectType)">
                            <a-upload
                              :data-index="index"
                              :action="uploadUrlb"
                              :fileList="fileList"
                              :headers="headers"
                              @preview="handlePreview"
                              @change="handleChange"
                              v-if="!type.show && type.optionSort == index"
                              :before-upload="beforeUpload"
                            >
                              <a-icon style="font-size: 26px;position: relative;top:2px;left: 0;" type="file-image" />
                            </a-upload>
                            <!--<a-modal :footer="null" @cancel="handleCancel">-->
                            <img alt="example" v-if="type.show" style="width: 30px;height: 30px" :src="type.picUrl2" />
                            <!--</a-modal>-->
                          </a-col>
                          <a-col :span="8">
                            <a-icon
                              style="font-size: 26px;position: relative;top:2px;left: 0;"
                              type="file-text"
                              @click="inputText(index, number, item.subjectType)"
                              v-if="!type.textshow"
                            />
                            <a-input v-model="type.optionText" style="height: 30px;text-align: center" v-else />
                          </a-col>
                          <a-col :span="3">
                            <a-checkbox
                              @change="onChangeoptions(index, number, item.subjectType)"
                              :checked="type.isDescription == 1 ? true : false"
                            ></a-checkbox
                          ></a-col>
                          <a-col :span="6"
                            ><a-checkbox
                              @change="onChangeRequired(index, number, item.subjectType)"
                              :checked="type.isRequiredDescription == 1 ? true : false"
                            ></a-checkbox
                          ></a-col>
                        </a-row>
                      </span>
                    </span>
                    <span
                      style="display: block;clear: both;margin-left: 70px;line-height: 26px;margin-top: 20px;margin-bottom: 20px"
                    >
                      <span style="display: inline-block" @click="addchoose(item.subjectType, number)">
                        <a-icon
                          style="font-size: 26px;margin-left: 10px;position: relative;top:2px"
                          type="plus-square"
                        />添加选项
                      </span>

                      <a-checkbox
                        @change="needReply(item.subjectType, number)"
                        style="margin: 0 15px"
                        :checked="item.isReply == 1 ? true : false"
                        >必答</a-checkbox
                      >
                    </span>
                    <div @click="FinallyState(number)" style="width: 100%;display: flex">
                      <a-button class="twobtn" type="primary" style="margin: 0 auto">完成编辑</a-button>
                    </div>
                  </div>
                </div>
              </div>
            </a-col>
            <a-col :span="24" style="display: flex;justify-content: center;align-content: center;margin: 30px 0px">
              <a-button class="twobtn" type="primary" style="width: 170px;height: 40px" @click="addModel(queryParam)"
                >提交模板编辑信息</a-button
              >
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
  </a-modal>
</template>

<script>
// 调接口
import { getDictMap } from '../../../utils/dict'
// 调接口
import { getList } from '@/api/order/orderList'
import { customerModelAdd, selectSubjectByModelId, updataModel } from '@/api/enterprise/customerModel'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import ARow from 'ant-design-vue/es/grid/Row'
import ACol from 'ant-design-vue/es/grid/Col'
import ATextarea from 'ant-design-vue/es/input/TextArea'
export default {
  components: { ATextarea, ACol, ARow },
  // name: 'EnterpriseCustomizationModal',
  data() {
    return {
      // 上传1
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=enterprise',
      fileList: [],
      fileListTitle: [],
      previewVisible: false,
      list: [{ imageUrl: '' }],
      urlList: '',
      visible: false,
      form: this.$form.createForm(this),
      value: 1,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        marginLeft: '20px'
      },
      Index: 0,
      Index2: 0,
      danxuanNo: [],
      timuNo: 0,
      timuNo2: 0,
      timuNo3: 0,
      timuNo4: 0,
      danxuanState: [],

      duoxuanNo: [],
      state: 0,
      xialaNo: [],
      wenbenNo: [],
      stateTwo: '',
      Index3: '',
      subjectList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 查询参数
      queryParam: {},
      List: [],
      // 字典为是否
      restaurantTypes: [],
      // 字典为安装类型
      installTypes: [],
      disableded: false,
      modelID: ''
    }
  },
  async created() {
    // 字典为安装类型
    this.installTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.installTypes.push({ code: key, label: value })
      // console.log(this.installTypes)
    })
  },
  methods: {
    add(record) {
      this.subjectList = []
      this.visible = true
      this.disableded = false
      this.queryParam = {}
    },
    edit(record) {
      this.queryParam.modelName = record.modelName
      this.queryParam.installType = record.installType
      this.queryParam.orderType = record.orderType
      this.disableded = true
      this.modelID = record.id
      console.log(record)
      this.visible = true

      selectSubjectByModelId({ modelId: record.id }).then(res => {
        console.log('res', res)
        if (res.code == 0) {
          for (let j = 0; j < res.rows.length; j++) {
            for (let i = 0; i < res.rows[j].optionList.length; i++) {
              res.rows[j].optionList[i].picUrl2 =
                process.env.VUE_APP_API_BASE_URL +
                '/dfs/download?fileName=' +
                res.rows[j].optionList[i].picUrl +
                '&token=' +
                Vue.ls.get(ACCESS_TOKEN)
              res.rows[j].optionList[i].show = true
              // this.subjectList[this.Index2].optionList[this.Index].show = true
            }
          }
          for (let j = 0; j < res.rows.length; j++) {
            for (let i = 0; i < res.rows[j].pictureList.length; i++) {
              res.rows[j].pictureList[i].allpicUrl =
                process.env.VUE_APP_API_BASE_URL +
                '/dfs/download?fileName=' +
                res.rows[j].pictureList[i].picUrl +
                '&token=' +
                Vue.ls.get(ACCESS_TOKEN)

              // res.rows[0].pictureList[i].picUrlstate = true
              // this.subjectList[this.Index2].optionList[this.Index].show = true
            }
          }
          this.subjectList = res.rows

          console.log(this.subjectList[0].edition)
          console.log(typeof this.subjectList[0].edition)

          for (var i = 0; i < this.subjectList.length; i++) {
            this.subjectList[i].edition = '0'
          }
        }
        console.log('开始', this.subjectList)
      })
    },
    addModel(data) {
      var allData = {}
      allData.modelName = data.modelName
      allData.installType = data.installType
      allData.orderType = data.orderType
      allData.subjectList = this.subjectList
      console.log('this.subjectList', allData.subjectList)
      for (let i = 0; i < allData.subjectList.length; i++) {
        if (allData.subjectList[i].disable == true || allData.subjectList[i].disable == undefined) {
        } else {
          if (allData.subjectList[i].pictureList.length == 0) {
            this.$message.success('上传图片不能为空')
          } else {
            if (allData.subjectList[i].pictureList[0].picUrl == '') {
              this.$message.success('上传图片不能为空')
              return
            }
          }
          for (let j = 0; j < allData.subjectList[i].optionList.length; j++) {
            // if(allData.subjectList[i].picUrlstate ) {
            if (allData.subjectList[i].optionList[j].picUrl == '') {
              this.$message.success('上传图片不能为空')
              return
            }
          }
        }
      }

      if (this.disableded) {
        allData.id = this.modelID
        updataModel(allData).then(res => {
          console.log(res.msg)
          if (res.code == 0) {
            this.$message.success('模板更新成功')
            this.visible = false
            this.$emit('ok', 2)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        customerModelAdd(allData).then(res => {
          console.log(res.msg)
          if (res.code == 0) {
            this.$message.success('模板新建成功')
            this.visible = false
            this.$emit('ok', 1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    //添加模板编辑
    editState(number) {
      console.log(this.subjectList)
      console.log(this.subjectList[number])
      console.log(this.subjectList[number].edition)
      console.log(this.subjectList[number].id)
      for (var i = 0; i < this.subjectList.length; i++) {
        this.subjectList[i].edition = '0'
      }
      this.subjectList[number].edition = '1'
    },
    FinallyState(number) {
      this.subjectList[number].edition = '0'
    },
    //删除该题型
    delState(number) {
      this.subjectList.splice(number, 1)
    },
    //数组元素互换位置
    swapArray(arr, index1, index2) {
      var sort1 = arr[index1].sort
      var sort2 = arr[index2].sort
      arr[index1].sort = sort2
      arr[index2].sort = sort1
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    //上移一步
    upState(number) {
      if (number == 0) {
        this.$message.error('已经是第一题，无法上移')
      } else {
        this.swapArray(this.subjectList, number - 1, number)
      }
    },
    //下移一步
    downState(number) {
      if (number == this.subjectList.length - 1) {
        this.$message.error('已经是最后一题，无法下移')
      } else {
        this.swapArray(this.subjectList, number, number + 1)
      }
    },
    //上移到顶部
    uptopState(number) {
      if (number == 0) {
        this.$message.error('已经是最前，无法上移')
      } else {
        var sort1 = this.subjectList[0].sort
        this.subjectList[number].sort = sort1 - 1
        for (var i = 0; i < this.subjectList.length; i++) {
          this.subjectList[i].sort++
          if (this.subjectList[i].sort > number + 1) {
            this.subjectList[i].sort--
          }
          console.log(this.subjectList[i].sort)
        }
        console.log(number)
        this.subjectList.unshift(this.subjectList[number])
        this.subjectList.splice(number + 1, 1)
      }
    },
    //下移到最后
    downbottomState(number) {
      if (number == this.subjectList.length - 1) {
        this.$message.error('已经是最后，无法下移')
      } else {
        var max = this.subjectList.length
        var sort1 = this.subjectList[max - 1].sort
        this.subjectList[number].sort = sort1 + 1
        for (var i = 0; i < this.subjectList.length; i++) {
          this.subjectList[i].sort--
          if (this.subjectList[i].sort < number) {
            this.subjectList[i].sort++
          }
          console.log(this.subjectList[i].sort)
        }
        var array = this.subjectList[number]
        this.subjectList.splice(number, 1)
        this.subjectList.push(array)
      }
    },
    //点击添加选项
    addchoose(state, number) {
      let index = this.subjectList[number].optionList.length
      this.subjectList[number].optionList.push({
        optionName: '',
        optionSort: index,
        picUrl: '',
        picUrl2: '',
        show: false,
        optionText: '',
        textshow: false,
        isDescription: 0,
        isRequiredDescription: 0
      })
      console.log('数据初始值', this.subjectList)
    },
    //点击减少当前选项
    reducechoose(index, number, state) {
      console.log(index, number, state)
      this.subjectList[number].optionList.splice(index, 1)
    },
    handleChange({ fileList }) {
      console.log(fileList)

      this.fileList = fileList
      this.subjectList[this.Index2].optionList[this.Index].picUrl = fileList[0].response.url

      this.subjectList[this.Index2].optionList[this.Index].picUrl2 =
        process.env.VUE_APP_API_BASE_URL +
        '/dfs/download?fileName=' +
        fileList[0].response.url +
        '&token=' +
        Vue.ls.get(ACCESS_TOKEN)
      this.subjectList[this.Index2].optionList[this.Index].show = true
      console.log('this.subjectList', this.subjectList)
      this.fileList = ''
    },
    handleChangeTitle({ fileList }) {
      console.log(fileList)
      this.fileListTitle = fileList
      console.log('上传前', this.subjectList)
      this.subjectList[this.Index3].pictureList.push({
        allpicUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + fileList[0].response.url,
        picUrl: fileList[0].response.url
      })
      console.log(fileList[0].response.url)
      console.log('上传中', this.subjectList)
      console.log('this.Index3', this.Index3)
      // this.subjectList[this.Index3].pictureList[0].picUrl = fileList[0].response.url
      this.subjectList[this.Index3].picUrlstate = true
      console.log('上传后', this.subjectList)
      this.fileListTitle = ''
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('请上传JPG、PNG格式的图片')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB!')
      }
      return isJpgOrPng && isLt2M
    },
    dianji(index, number, state) {
      console.log(index)
      this.Index = index
      this.Index2 = number
      this.state = state
    },
    titlepic(number, state) {
      this.stateTwo = state
      this.Index3 = number
    },
    inputText(index, number, state) {
      this.subjectList[number].optionList[index].textshow = true
    },
    needReply(state, number) {
      if (this.subjectList[number].isReply == 0) {
        this.subjectList[number].isReply = 1
      } else {
        this.subjectList[number].isReply = 0
      }
    },
    onChangeoptions(index, number, state) {
      if (this.subjectList[number].optionList[index].isDescription == 0) {
        this.subjectList[number].optionList[index].isDescription = 1
      } else {
        this.subjectList[number].optionList[index].isDescription = 0
      }
    },
    onChangeRequired(index, number, state) {
      if (this.subjectList[number].optionList[index].isRequiredDescription == 0) {
        this.subjectList[number].optionList[index].isRequiredDescription = 1
      } else {
        this.subjectList[number].optionList[index].isRequiredDescription = 0
      }
    },
    danxuan() {
      this.timuNo++
      this.subjectList.push({
        optionList: [
          {
            optionName: '是',
            optionSort: '0',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0
          },
          {
            optionName: '否',
            optionSort: '1',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0
          }
        ],
        sort: this.timuNo,
        subjectName: '标题',
        picUrl: '',
        picUrlstate: false,
        isReply: 0,
        subjectType: '0',
        pictureList: [],
        edition: '0'
      })
    },
    duoxuan() {
      this.timuNo++
      this.subjectList.push({
        optionList: [
          {
            optionName: '选项1',
            optionSort: '0',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0
          },
          {
            optionName: '选项2',
            optionSort: '1',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0
          }
        ],
        sort: this.timuNo,
        subjectName: '标题',
        picUrl: '',
        picUrlstate: false,
        isReply: 0,
        subjectType: '1',
        pictureList: [],
        edition: '0'
      })
    },
    xiala() {
      this.timuNo++
      this.subjectList.push({
        optionList: [
          {
            optionName: '选项1',
            optionSort: '0',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0
          },
          {
            optionName: '选项2',
            optionSort: '1',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0
          }
        ],
        sort: this.timuNo,
        subjectName: '标题',
        picUrl: '',
        picUrlstate: false,
        isReply: 0,
        subjectType: '2',
        pictureList: [],
        edition: '0'
      })
    },
    wenben() {
      this.timuNo++
      this.subjectList.push({
        sort: this.timuNo,
        subjectName: '标题',
        disable: true,
        minLength: '0',
        maxLength: '100',
        picUrl: '',
        picUrlstate: false,
        isReply: 0,
        subjectType: '3',
        pictureList: [],
        edition: '0'
      })
    },
    onChanged(number) {
      if (this.subjectList[number].disable == false) {
        this.subjectList[number].disable = true
        this.subjectList[number].min = 0
        this.subjectList[number].max = 100
      } else {
        this.subjectList[number].disable = false
      }
    },
    async installChange(e) {
      this.List = []
      await getList(e).then(res => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.twobtn {
  background-color: #169bd5;
  color: white;
  width: 90px;
  font-size: 15px;
  margin: 2px 0;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
</style>
